import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdateBankAccountComponent } from './update-bank-account/update-bank-account.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
    MatAutocompleteModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule, MatProgressSpinnerModule, MatRadioModule,
    MatSelectModule
} from '@angular/material';
import {CameraDirectiveModule} from '../../directives/camera-directive.module';
import {LoanApplicationFlowModule} from '../../loan-application-flow-component/loan-application-flow.module';
import { BankAccountDetailsByNameComponent } from './bank-account-details-by-name/bank-account-details-by-name.component';
import { BankAccountDetailsByIfscComponent } from './bank-account-details-by-ifsc/bank-account-details-by-ifsc.component';



@NgModule({
  declarations: [UpdateBankAccountComponent, BankAccountDetailsByNameComponent, BankAccountDetailsByIfscComponent],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        MatFormFieldModule,
        MatSelectModule,
        MatButtonModule,
        MatDialogModule,
        CameraDirectiveModule,
        MatAutocompleteModule,
        MatRadioModule,
        LoanApplicationFlowModule,
        MatProgressSpinnerModule
    ]
})
export class BankAccountModule { }
